import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
} from "reactstrap";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import moment from "moment";
import { useParams } from "react-router-dom";


function VistaPedido() {
  const { user } = useContext(AuthContext);
  const { idPedido } = useParams();
  const URL_PEDIDOS = import.meta.env.VITE_URL_PEDIDOS;
  const URL_ARTICULOS_PEDIDO = import.meta.env.VITE_URL_ARTICULOS_PEDIDO;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 30);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  useEffect(() => {
    if(idPedido){
    PDFOC(idPedido);
    }
  }, [idPedido]);

 
  // async function PDFOCFoto(
  //   fecha,
  //   colaboradores,
  //   idClientes,
  //   clientes,
  //   total_cantidad,
  //   total_general,
  //   observaciones,
  //   numero,
  //   impuestos,
  //   comisionFlete,
  //   comisionTDC,
  //   idPDFOC,
  //   alias,
  //   calle,
  //   numero_ext,
  //   numero_int,
  //   pais,
  //   estado,
  //   ciudad,
  //   delegacion,
  //   colonia,
  //   cp,
  //   RFC,
  //   paqueteria,
  //   area,
  //   codigoClientes,
  //   autorizadoApartado,
  //   autorizadoSurtido,
  //   telefono,
  //   editado,
  //   editPedido,
  //   autorizoApartado,
  //   autorizoSurtido,
  //   descuento,
  //   creado,
  //   fechaHora
  // ) {
  //   await axios
  //     .get(`${URL_ARTICULOS_PEDIDO}/surtir2/${idPDFOC}`, {
  //       headers: {
  //         Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //       },
  //     })
  //     .then((response) => {
  //       let allArticulosPedido = response.data;
  //       let arrayTabla = allArticulosPedido
  //         .map((a) => {
  //           return {
  //             id: a._id,
  //             articulos: a.articulos[0].codigo,
  //             idArticulo: a.articulos[0]._id,
  //             observaciones: a.observaciones,
  //             cantidad: a.cantidad,
  //             surtido: a.surtido,
  //             precio: a.precio,
  //             total: a.total,
  //             pendiente_surtir: a.pendiente_surtir,
  //             cajas: a.cantidad / a.articulos[0].piezasPorCaja,
  //             foto: ""
  //           };
  //         })
  //         .filter(function (el) {
  //           return el != null;
  //         });

  //       let dataFinal = Object.values(arrayTabla);

  //       let agrupado = dataFinal.reduce(function (groups, item) {
  //         const val = item["idArticulo"]
  //         groups[val] = groups[val] || {
  //           idArticulo: item.idArticulo,
  //           cantidad: 0,
  //           total: 0,
  //           pendiente_surtir: 0,
  //           cajas: 0
  //         };
  //         groups[val].cantidad += item.cantidad;
  //         groups[val].idArticulo = item.idArticulo;
  //         groups[val].articulos = item.articulos;
  //         groups[val].precio = item.precio;
  //         groups[val].total += item.total;
  //         groups[val].pendiente_surtir += item.pendiente_surtir;
  //         groups[val].cajas += item.cajas;
  //         groups[val].foto = item.foto

  //         return groups;
  //       },[])

  //       let dataAgrupado = Object.values(agrupado);

  //       let totalKG = dataFinal.map((c) => parseFloat(c.cantidad));
  //       let TK = totalKG.reduce((t, total, index) => t + total, 0);

  //       let importes = dataFinal.map((c) => parseFloat(c.total));
  //       let TG = importes.reduce((t, total, index) => t + total, 0);

  //       let TC = dataFinal.map((c) => parseFloat(c.cajas));
  //       let TTC = TC.reduce((t, total, index) => t + total, 0);

  //       let iva_tabla = (TG * impuestos) / 100;

  //       let temp1 = (TG * descuento) / 100;

  //       dataAgrupado.map(async (z) => {
  //         const URL_GET_MEDIA = `${import.meta.env.VITE_URL_GETMEDIA}/${z.idArticulo}`;
  //        await axios
  //           .get(URL_GET_MEDIA, {
  //             headers: {
  //               Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //             },
  //           })
  //           .then((data) => {
  //             if(data.data.secure_url != null){
  //             z.foto = data.data.secure_url
  //           }else z.foto = "sinImagen.png"
  //           })
  //           .catch((err) => {
  //             console.log(err);
  //           });
  //         return z
  //       })

  //       setTimeout(() => {

  //       const data = dataFinal
  //       .sort((a, b) => (a.articulos > b.articulos ? 1 : -1))
  //       .map((a) => {
  //         // totalParcial = a.cantidad * a.precio;
  //         // subTotalTabla = subTotalTabla + totalParcial
  //         // iva_tabla = iva_tabla + (subTotalTabla * impuesto_tabla/100)
  //         return [
  //           a.foto,
  //           a.articulos,
  //           new Intl.NumberFormat("en-US").format(a.cantidad),
  //           // new Intl.NumberFormat("en-US").format(a.surtido),
  //           new Intl.NumberFormat("en-US", {
  //             style: "currency",
  //             currency: "USD",
  //             maximumFractionDigits: 2,
  //           }).format(a.precio),
  //           new Intl.NumberFormat("en-US", {
  //             style: "currency",
  //             currency: "USD",
  //             maximumFractionDigits: 2,
  //           }).format(a.total),
  //         ];
  //       });
  //       const dataPDF = Object.values(data);
  //       const dataPDFLimpia = dataPDF.filter(function (el) {
  //         return el != null;
  //       });
  //       const doc = new jsPDF();
  //       // const doc = new jsPDF("landscape","mm", "a4", true);
  //       var img = new Image();
  //       img.src = "Logo-Sistemify-PDF.png";
  //       doc.addImage(img, "png", 8, 5, 18, 5);
  //       var img2 = new Image();
  //       img2.src = "logoInstitucion.png";
  //       doc.addImage(img2, "png", 10, 11, 20, 10);

  //       doc.setFontSize(16);
  //       doc.text(`No. Pedido: ${numero}`, 35, 15);
  //       // doc.text(`Fecha:`, 35, 15);
  //       // doc.text(`${fecha}`, 60, 15);

  //       doc.setFontSize(12);
  //       doc.text(`Ejecutivo:`, 120, 15);
  //       doc.text(`${colaboradores}`, 150, 15);
  //       doc.text(`Aut. Apartado:`, 120, 20);
  //       doc.text(`${autorizadoApartado}`, 150, 20);
  //       doc.text(`Aut. Surtido:`, 120, 25);
  //       doc.text(`${autorizadoSurtido}`, 150, 25);

  //       doc.setFontSize(8);
  //       doc.text(`Creado por: ${creado}`, 120, 32);
  //       doc.text(`Fecha creado: ${fechaHora}`, 120, 37);

  //       doc.text(`Cliente: ${codigoClientes} - ${clientes}`, 10, 32);
  //       doc.text(`RFC: ${RFC}`, 10, 37);
  //       doc.text(`Direccion de Envio: ${calle} #${numero_ext} Int. ${numero_int}`, 10, 47);
  //       doc.text(`Telefono: ${telefono}`, 10, 52);
  //       doc.text(`Edo: ${estado}, Ciudad: ${ciudad}, CP: ${cp}`, 10, 57);
  //       doc.text(`Del: ${delegacion}, Col: ${colonia}`, 10, 62);

  //       doc.setFontSize(12);
  //       doc.text(`Paqueteria: ${paqueteria}`, 120, 50);
  //       doc.text(`Almacen: ${area}`, 120, 57);
  //       doc.autoTable({
  //         columnStyles: {
  //           0: {
  //             fontSize: .0001,
  //             cellWidth: 20,
  //           },
  //         },
  //         // columnStyles: {
  //         //   0: {cellWidth: 37},
  //         //   1: {cellWidth: 60},
  //         //   2: {cellWidth: 15},
  //         //   3: {cellWidth: 17},
  //         //   4: {cellWidth: 17},
  //         //   5: {cellWidth: 20},
  //         //   6: {cellWidth: 22},
  //         // },
  //         head: [
  //           [
  //             "Foto",
  //             "Articulo",
  //             "Cant.",
  //             // "Surt.",
  //             "Precio",
  //             "Total",
  //           ],
  //         ],
  //         body: dataPDFLimpia,
  //         bodyStyles:{
  //           rowHeight : 22
  //         },
  //         styles: {
  //           fontSize: 10,
  //         },
  //         startY: 70,

  //         didDrawCell: function(data) {
  //           if (data.column.index === 0 && data.cell.section === 'body') {
  //              var td = data.cell.raw;
  //              var img3 = td
  //             //  var dim = data.cell.height - data.cell.padding('vertical');
  //              var textPos = data.cell;
  //              doc.addImage(img3, textPos.x,  textPos.y, 20, 20);
  //           }
  //         },

  //         margin:{left:10, right:10},
  //         foot: [
  //           [
  //             "",
  //             // "",
  //             new Intl.NumberFormat("en-US").format(TK) + " Piezas",
  //             "",
  //             "Sub Total",
  //             new Intl.NumberFormat("en-US", {
  //               style: "currency",
  //               currency: "USD",
  //               maximumFractionDigits: 2,
  //             }).format(TG),
  //           ],
  //           [
  //             "",
  //             // "",
  //             "",
  //             "",
  //             `IVA`,
  //             new Intl.NumberFormat("en-US", {
  //               style: "currency",
  //               currency: "USD",
  //               maximumFractionDigits: 2,
  //             }).format(iva_tabla),
  //           ],
  //           [
  //             "",
  //             // "",
  //             "",
  //             "",
  //             "Comision TDC",
  //             new Intl.NumberFormat("en-US", {
  //               style: "currency",
  //               currency: "USD",
  //               maximumFractionDigits: 2,
  //             }).format(comisionTDC),
  //           ],
  //           [
  //             "",
  //             "",
  //             // "",
  //             "",
  //             "Flete",
  //             new Intl.NumberFormat("en-US", {
  //               style: "currency",
  //               currency: "USD",
  //               maximumFractionDigits: 2,
  //             }).format(comisionFlete),
  //           ],
  //           [
  //             "",
  //             // "",
  //             "",
  //             "",
  //             `Desc ${descuento}%`,
  //             new Intl.NumberFormat("en-US", {
  //               style: "currency",
  //               currency: "USD",
  //               maximumFractionDigits: 2,
  //             }).format(-temp1),
  //           ],
  //           [
  //             "",
  //             // "",
  //             "",
  //             "",
  //             "Total",
  //             new Intl.NumberFormat("en-US", {
  //               style: "currency",
  //               currency: "USD",
  //               maximumFractionDigits: 2,
  //             }).format(total_general),
  //           ],
  //         ],
  //         showFoot: "lastPage",
  //       });

  //       doc.setFontSize(10);
  //       var lines = doc.splitTextToSize(`Observaciones ${observaciones}`, 200);
  //       doc.text(10, doc.autoTable.previous.finalY + 10, lines);

  //       window.open(doc.output("bloburl"), "_blank");

  //     }, 1000);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }

  async function PDFOC(
    idPedido
  ) {

        await axios
      .get(`${URL_PEDIDOS}/${idPedido}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(async(pedido) => {
        let dataPedido = pedido.data;

        console.log("hola","");

        
    let colaboradores = dataPedido.colaboradores[0].nombre + " " + dataPedido.colaboradores[0].apellido
    let clientes = dataPedido.clientes[0].nombre_comercial
    let total_general = dataPedido.total_general
    let observaciones = dataPedido.observaciones
    let numero = dataPedido.idPedido
    let impuestos = dataPedido.impuestos
    let comisionFlete = dataPedido.comisionFlete
    let comisionTDC = dataPedido.comisionTDC
    let calle = dataPedido.calle
    let numero_ext = dataPedido.numero_ext
    let numero_int = dataPedido.numero_int
    let estado = dataPedido.estado
    let ciudad = dataPedido.ciudad
    let delegacion = dataPedido.delegacion
    let colonia = dataPedido.colonia
    let cp = dataPedido.cp
    let RFC = dataPedido.RFC
    let paqueteria = dataPedido.paqueterias[0]?.name || ""
    let area = dataPedido.areas[0].name
    let codigoClientes = dataPedido.codigoClientes
    let autorizadoApartado = dataPedido.autorizadoApartado
    let autorizadoSurtido = dataPedido.autorizadoSurtido
    let telefono = dataPedido.telefono
    let descuento = dataPedido.descuento
    let creado = dataPedido.creado[0].nombre + " " + dataPedido.creado[0].apellido
    let fechaHora = moment(dataPedido.createdAt).utcOffset("-0600").format("DD-MM-YYYY") + " " +moment(dataPedido.createdAt).utcOffset("-0600").format("HH:mm:ss")

    await axios
      .get(`${URL_ARTICULOS_PEDIDO}/surtir2/${idPedido}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosPedido = response.data;
        let arrayTabla = allArticulosPedido
          .map((a) => {
            return {
              id: a._id,
              articulos: a.articulos[0].codigo,
              idArticulo: a.articulos[0]._id,
              observaciones: a.observaciones,
              cantidad: a.cantidad,
              surtido: a.surtido,
              precio: a.precio,
              total: a.total,
              pendiente_surtir: a.pendiente_surtir,
              cajas: a.cantidad / a.articulos[0].piezasPorCaja,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        let agrupado = dataFinal.reduce(function (groups, item) {
          const val = item["idArticulo"];
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
            cantidad: 0,
            total: 0,
            pendiente_surtir: 0,
            cajas: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].idArticulo = item.idArticulo;
          groups[val].articulos = item.articulos;
          groups[val].precio = item.precio;
          groups[val].total += item.total;
          groups[val].pendiente_surtir += item.pendiente_surtir;
          groups[val].cajas += item.cajas;

          return groups;
        }, []);

        let dataAgrupado = Object.values(agrupado);

        let totalKG = dataFinal.map((c) => parseFloat(c.cantidad));
        let TK = totalKG.reduce((t, total, index) => t + total, 0);

        let importes = dataFinal.map((c) => parseFloat(c.total));
        let TG = importes.reduce((t, total, index) => t + total, 0);

        let TC = dataFinal.map((c) => parseFloat(c.cajas));
        let TTC = TC.reduce((t, total, index) => t + total, 0);

        let iva_tabla = (TG * impuestos) / 100;

        let temp1 = (TG * descuento) / 100;

        const data = dataAgrupado
          .sort((a, b) => (a.articulos > b.articulos ? 1 : -1))
          .map((a) => {
            // totalParcial = a.cantidad * a.precio;
            // subTotalTabla = subTotalTabla + totalParcial
            // iva_tabla = iva_tabla + (subTotalTabla * impuesto_tabla/100)
            return [
              a.articulos,
              new Intl.NumberFormat("en-US").format(a.cantidad),
              // new Intl.NumberFormat("en-US").format(a.surtido),
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(a.precio),
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(a.total),
            ];
          });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF();
        // const doc = new jsPDF("landscape","mm", "a4", true);
        var img = new Image();
        // img.src = "Logo-Sistemify-PDF.png";
        // doc.addImage(img, "png", 8, 5, 18, 5);
        // var img2 = new Image();
        // img2.src = "logoInstitucion.png";
        // doc.addImage(img2, "png", 10, 11, 20, 10);

        doc.setFontSize(16);
        doc.text(`No. Pedido: ${numero}`, 35, 15);
        // doc.text(`Fecha:`, 35, 15);
        // doc.text(`${fecha}`, 60, 15);

        doc.setFontSize(12);
        doc.text(`Ejecutivo:`, 120, 15);
        doc.text(`${colaboradores}`, 150, 15);
        doc.text(`Aut. Apartado:`, 120, 20);
        doc.text(`${autorizadoApartado}`, 150, 20);
        doc.text(`Aut. Surtido:`, 120, 25);
        doc.text(`${autorizadoSurtido}`, 150, 25);

        doc.setFontSize(8);
        doc.text(`Creado por: ${creado}`, 120, 32);
        doc.text(`Fecha creado: ${fechaHora}`, 120, 37);

        doc.text(`Cliente: ${codigoClientes} - ${clientes}`, 10, 32);
        doc.text(`RFC: ${RFC}`, 10, 37);
        doc.text(
          `Direccion de Envio: ${calle} #${numero_ext} Int. ${numero_int}`,
          10,
          47
        );
        doc.text(`Telefono: ${telefono}`, 10, 52);
        doc.text(`Edo: ${estado}, Ciudad: ${ciudad}, CP: ${cp}`, 10, 57);
        doc.text(`Del: ${delegacion}, Col: ${colonia}`, 10, 62);

        doc.setFontSize(12);
        doc.text(`Paqueteria: ${paqueteria}`, 120, 50);
        doc.text(`Almacen: ${area}`, 120, 57);
        doc.autoTable({
          head: [
            [
              "Articulo",
              "Cant.",
              // "Surt.",
              "Precio",
              "Total",
            ],
          ],
          body: dataPDFLimpia,
          styles: {
            fontSize: 10,
          },
          startY: 70,

          margin: { left: 10, right: 10 },
          foot: [
            [
              "",
              new Intl.NumberFormat("en-US").format(TK) + "Piezas",
              "Sub Total",
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(TG),
            ],
            [
              "",
              "",
              `IVA`,
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(iva_tabla),
            ],
            [
              "",
              "",
              "Comision TDC",
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(comisionTDC),
            ],
            [
              "",
              "",
              "Flete",
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(comisionFlete),
            ],
            [
              "",
              "",
              `Desc ${descuento}%`,
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(-temp1),
            ],
            [
              "",
              "",
              "Total",
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(total_general),
            ],
          ],
          showFoot: "lastPage",
        });

        doc.setFontSize(10);
        var lines = doc.splitTextToSize(`Observaciones ${observaciones}`, 200);
        doc.text(10, doc.autoTable.previous.finalY + 10, lines);

        // window.open(doc.output("bloburl"), "_blank");
        window.open(doc.output("bloburl"), "_blank");
      })
      .catch((err) => {
        console.log(err);
      })
    })
      .catch((err) => {
        console.log(err);
      })
  }

 
  return (
    <>

    <h4>Se esta descargando el pedido</h4>
    

    </>
  );
}

export default VistaPedido;
